import { reportMetrics } from './reportMetrics';
import { apiDuration, apiErrorTotal } from './metrics/creates';

function getDevice() {
  if (typeof window === 'undefined') return 'unknown';
  return window.innerWidth >= 768 ? 'pc' : 'mobile';
}

export function createAxiosInterceptors(axiosInstance, apiGroup) {
  axiosInstance.interceptors.request.use(
    (config) => {
      config._startTime = Date.now();
      return config;
    },
    (error) => Promise.reject(error),
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      const duration = Date.now() - (response.config._startTime || Date.now());
      const path = extractPath(response.config.url || '');
      const device = getDevice();

      reportMetrics(
        apiDuration(duration, {
          path,
          method: (response.config.method || 'get').toUpperCase(),
          code: String(response.status),
          api_group: apiGroup,
          device,
        }),
      );

      return response;
    },
    (error) => {
      const config = error.config || {};
      const duration = Date.now() - (config._startTime || Date.now());
      const path = extractPath(config.url || '');
      const code = String(error.response?.status || 0);
      const device = getDevice();

      reportMetrics([
        apiDuration(duration, {
          path,
          method: (config.method || 'get').toUpperCase(),
          code,
          api_group: apiGroup,
          device,
        }),
        apiErrorTotal({
          path,
          code,
          error_type: error.response ? 'http_error' : 'network_error',
          api_group: apiGroup,
          device,
        }),
      ]);

      return Promise.reject(error);
    },
  );
}

function extractPath(url) {
  try {
    const u = new URL(url, window.location.origin);
    return u.pathname;
  } catch {
    return url.split('?')[0];
  }
}

export function instrumentAxios(axiosLib, defaultApiGroup = 'default') {
  if (!axiosLib || axiosLib.__sppInstrumented) return axiosLib;
  axiosLib.__sppInstrumented = true;

  createAxiosInterceptors(axiosLib, defaultApiGroup);

  const originalCreate = axiosLib.create;
  if (typeof originalCreate === 'function') {
    axiosLib.create = function patchedCreate(config) {
      const instance = originalCreate.call(axiosLib, config);
      createAxiosInterceptors(instance, defaultApiGroup);
      return instance;
    };
  }
  return axiosLib;
}
